const config = {
  sandbox: {
    application: 'transactions',
    basePath: '/usis/transactions',
    port: 3000,
    sslPort: 3443,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Credentials': true,
      'X-TRP-Requested-With': 'XMLHttpRequest',
    },
    splunk: {
      url: 'https://splunkcollector.stage.awstrp.net:443',
      host: '', // will be set dynamically in servers.js
      token: '34DF2719-114D-4A07-9C47-A9C7AF4E1B09',
      name: 'Splunk-AppLog',
      source: 'transactions_ui',
      sourceType: 'APP',
      index: 'trpapps_dev_log'
    },
    vault: 'https://vault.dev.troweprice.io:8200',
    api: {
      host: 'https://api.dev.troweprice.com',
      internal: 'https://api.dev.awstrp.net'
    },
    url: window && window.location
      ? `${window.location.protocol}//${window.location.hostname}:${window.location.port}`
      : 'http://localhost:3000',
    clxUrl: 'https://www3dev.troweprice.com',
    individual: 'https://individual.troweprice.com',
    pdUrl: '/clx-tk/token-exchange/redirect/transactions',
    rmlUrl: 'https://wwwstage.troweprice.com',
    userUrl: 'https://www3qual.troweprice.com/usis/personal-investing/relationship-manager/',
    foresee: 'https://preview-survey.foresee.com/f/rPnI1gAlIk',
    cui: {
      url: 'https://apidev.awstrp.net/cuirouter/send',
      key: 'b3RaU2rRzZoI674Zv7wgkeQlZAZjrcfh'
    },
    debug: {
      enableReduxDevTools: true
    }
  },
  dev: {
    application: 'transactions',
    basePath: '/usis/transactions',
    port: 3000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Credentials': true,
      'X-TRP-Requested-With': 'XMLHttpRequest'
    },
    debug: {
      entableReduxDevTools: false
    },
    splunk: {
      url: 'https://splunkcollector.stage.awstrp.net:443',
      host: '', // set dynamically in server.js
      name: 'Splunk-AppLog',
      token: '34DF2719-114D-4A07-9C47-A9C7AF4E1B09',
      source: 'transactions_ui',
      sourceType: 'APP',
      index: 'trpapps_dev_log'
    },
    vault: 'https://vault.dev.troweprice.io:8200',
    api: {
      host: 'https://api.dev.troweprice.com',
      internal: 'https://api.dev.awstrp.net'
    },
    url: 'https://wwwdev.troweprice.com',
    clxUrl: 'https://www3dev.troweprice.com',
    caimUrl: 'https://wwwdev.troweprice.com/v0/ciam-public/me',
    individual: 'https://individual.troweprice.com',
    internal: {
      host: ''
    },
    logout: {
      app: 'https://www3dev.troweprice.com/aaweb1/accountAccess/page/logout.do',
      adfs: 'https://fs.trowe3.com/adfs/oauth2/logout'
    },
    pdUrl: '/clx-tk/token-exchange/redirect/transactions',
    rmlUrl: 'https://wwwdev.troweprice.com',
    userUrl: 'https://www3qual.troweprice.com/usis/personal-investing/relationship-manager/',
    foresee: 'https://preview-survey.foresee.com/f/rPnI1gAlIk',
    cui: {
      url: 'https://apidev.awstrp.net/cuirouter/send',
      key: 'b3RaU2rRzZoI674Zv7wgkeQlZAZjrcfh'
    },
    serviceHost: 'https://api.dev.awstrp.net/',
    applicationRequiredEntitlements: [],
    optionalPanelEntitlements: ['iusers'],
    allowedAuthentication: 'both',
    localhostAuthType: 'external',
    baseEnvHost: 'https://api.dev.awstrp.net/',
    customerWebViewEnabled: true,
    authorizePath: 'nitro_oauth-common-callback/login',
    sandboxAuthCookieEnabled: false,
    apiKey: 'wYNJS1h4vObY1rkHzW05COnqleATlsgJ',
    logoutUrls: [
      'architecture-reference-implementations_oauth-callback-reference-svc/logout',
      'https://fs.trowe3.com/adfs/oauth2/logout'
    ]
  },
  stage: {
    application: 'transactions',
    basePath: '/usis/transactions',
    port: 3000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Credentials': true,
      'X-TRP-Requested-With': 'XMLHttpRequest'
    },
    splunk: {
      url: 'https://splunkcollector.stage.awstrp.net:443',
      host: '',
      name: 'Splunk-AppLog',
      token: '3371E106-19AE-4FB4-8373-EFC6170A6008',
      source: 'transactions_ui',
      sourceType: 'APP',
      index: 'trpapps_stage'
    },
    vault: 'https://vault.stage.troweprice.io:8200',
    api: {
      host: 'https://api.confidence.troweprice.com',
      internal: 'https://api.stage.awstrp.net'
    },
    url: 'https://wwwstage.troweprice.com',
    clxUrl: 'https://www3qual.troweprice.com',
    individual: 'https://individual.troweprice.com',
    pdUrl: '/clx-tk/token-exchange/redirect/transactions',
    rmlUrl: 'https://wwwstage.troweprice.com',
    userUrl: 'https://www3qual.troweprice.com/usis/personal-investing/relationship-manager/',
    foresee: 'https://survey.foresee.com/f/rPnI1gAlIk',
    cui: {
      url: 'https://api.stage.awstrp.net/cuirouter/send',
      key: 'GAL1xfkY5O49a9AK2EdV6eKIy3aaVMU3'
    },
    debug: {
      enableReduxDevTools: true
    },
  },
  prod: {
    application: 'transactions',
    basePath: '/usis/transactions',
    port: 3000,
    api: {
      host: 'https://api.public.troweprice.com',
      internal: 'https://api.prod.awstrp.net'
    },
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Credentials': true,
      'X-TRP-Requested-With': 'XMLHttpRequest'
    },
    splunk: {
      url: 'https://splunkcollector.awstrp.net:443',
      host: '', // set dynamically in server.js
      name: 'Splunk-AppLog',
      token: 'AA5F0267-A4C6-477F-925C-3CC40A5F5AFB',
      source: 'transactions_ui',
      sourceType: 'APP',
      index: 'trpapps'
    },
    url: 'https://www.troweprice.com',
    individual: 'https://individual.troweprice.com',
    clxUrl: 'https://www3.troweprice.com',
    pdUrl: '/clx-tk/token-exchange/redirect/transactions',
    rmlUrl: 'https://www.troweprice.com',
    userUrl: 'https://www3.troweprice.com/usis/personal-investing/relationship-manager/',
    foresee: 'https://survey.foresee.com/f/rPnI1gAlIk',
    cui: {
      url: 'https://api.public.troweprice.com/cuirouter/send',
      key: 'lmtPEUGwuHn7aOPLmOEkAGkTyVfG9GYf'
    },
    debug: {
      enableReduxDevTools: false
    },
    vault: 'https://vault.troweprice.io:8200'
  }
};

let env = {};
// secondary flag doesn't actually pass since __CONFIG__ is evaluated during build
if (typeof location !== 'undefined' && !location.host.includes('localhost')) { // eslint-disable-line no-restricted-globals
  if( location.host.includes('dev')) {// eslint-disable-line no-restricted-globals
    env = config['dev'];
  } else if( location.host.includes('stage')) {// eslint-disable-line no-restricted-globals
    env = config['stage'];
  } else {
    env = config['prod'];
  }
  if( location.host.includes('awstrp') && // eslint-disable-line no-restricted-globals
    !env.url.includes('awstrp')) {
    env.url = `https://${location.host}`; // eslint-disable-line no-restricted-globals
  }
} else {
  env = config['dev'];
}

export default env;

